import {
    FOOTER_DATA_START,
    FOOTER_DATA_SUCCESS,
    FOOTER_DATA_ERROR,
} from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function footerDataReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case FOOTER_DATA_START:
        return {
          ...state,
          loading: true,
        };
      case FOOTER_DATA_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case FOOTER_DATA_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  